import { render, staticRenderFns } from "./hivesItem.vue?vue&type=template&id=2eced6d0&"
import script from "./hivesItem.vue?vue&type=script&lang=js&"
export * from "./hivesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports